import { SpeakerFaceCoordinatesResponse } from '@goldcast/api/content';
import { getPlayerConfig } from '@/player-config/src/generators/config';
import { Clip } from '@/player-config/src/types/clip-types';
import { CompositionConfig } from '@/player-config/src/types/RemotionPlayerConfigTypes/CompositionConfig';
import { SceneChanges } from '@/player-config/src/types/scene-changes';
import { useContentMetadataStore } from '@/stores/contentMetaDataStore/contentMetaDataStore';
import {
  currentClip,
  isFullVideoFaceRecEnabled,
  isLayoutsEnabledForPreRecordedEventsFeatureFlag,
  isScreenShareDetectionFeatureFlagEnabled
} from '@/stores/clip';
import { zoomLevelStore } from '@/Pages/Clip/ClipPlayer/ClipNewTimeline/store/zoomLevel';
import featureFlagStore from '@/stores/featureFlagStore';
import { FeatureFlagKeys } from '@/services/featureFlag';
import { currentUser } from '@/stores/user';
import { brandKit, clipsBrandKit, platformBrandKitStore } from '@/stores/brandKit';
import { ContentMetadataStoreFactoryType } from '@/player-config/src/stores/contentMetadataStoreFactory';
import { BrandKitStore, PlatformBrandKitStore } from '@/player-config/src/types/brand-kit-types';

export const getImpureCommonPropsForPlayerConfigGeneration = (
  clipId: string
): {
  isFullFaceRecEnabled: boolean;
  areLayoutsEnabledForPreRecordedEvents: boolean;
  isScreenshareDetectionEnabled: boolean;
  isPlatformBrandKitEnabled: boolean;
  clipBrandKitStore: BrandKitStore;
  brandKitStore: BrandKitStore;
  platformBrandKit: PlatformBrandKitStore;
  organization?: string | null | undefined;
  isSplitsTranslationEnabled: boolean;
  zoomLevel: number;
  previousClip: Clip;
  contentMetadataStoreInstance: ContentMetadataStoreFactoryType;
} => {
  return {
    isFullFaceRecEnabled: isFullVideoFaceRecEnabled(),
    areLayoutsEnabledForPreRecordedEvents: isLayoutsEnabledForPreRecordedEventsFeatureFlag(),
    isScreenshareDetectionEnabled: isScreenShareDetectionFeatureFlagEnabled(),
    isPlatformBrandKitEnabled: !!featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_CL_Platform_Brandkit],
    clipBrandKitStore: clipsBrandKit.getSnapshot()[clipId],
    brandKitStore: brandKit.getSnapshot(),
    platformBrandKit: platformBrandKitStore.getSnapshot(),
    organization: currentUser.getSnapshot()?.organization,
    isSplitsTranslationEnabled: !!featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_CL_Splits_Translations],
    zoomLevel: zoomLevelStore.getSnapshot().zoomLevel,
    previousClip: currentClip.getSnapshot()[clipId],
    contentMetadataStoreInstance: useContentMetadataStore
  };
};

export const getPlayerConfigHelper = ({
  clip,
  sceneOverrides,
  shouldUpdatePlayerConfig,
  facialRecognitionToDefaultPosition
}: {
  clip: Clip;
  sceneOverrides?: SceneChanges;
  shouldUpdatePlayerConfig?: boolean;
  facialRecognitionToDefaultPosition?: SpeakerFaceCoordinatesResponse;
}): CompositionConfig => {
  return getPlayerConfig({
    clip,
    sceneOverrides,
    shouldUpdatePlayerConfig,
    facialRecognitionToDefaultPosition,
    ...getImpureCommonPropsForPlayerConfigGeneration(clip.id)
  });
};
